<template>
  <div class="tables-navigation" :style="{ backgroundColor }">
    <div class="d-contents spacex-8">
      <slot name="before-tabs" />
      <Tab
        :title="summaryRoute.name === 'summary' ? $t('Summary') : $t('Tender info')"
        colored
        :selected="summaryClass.current"
        @click.native="goToSummaryRoute"
      />
    </div>
    <Scrolly :class="scrollbarClass" class="overlay-wrap">
      <div
        class="fade-out-block"
        :style="{
          background: `linear-gradient(270deg, transparent, ${backgroundColor})`,
        }"
      />
      <!--  id нужен для скриптового скролла, не удалять его  -->
      <ScrollyViewport id="table-navigation-scroll" class="tables-tabs">
        <slot />
      </ScrollyViewport>
      <ScrollyBar axis="x" />
      <div
        v-if="showScrollActions"
        class="fade-out-block right"
        :style="{
          background: `linear-gradient(270deg, ${backgroundColor}, transparent)`,
        }"
      />
    </Scrolly>
    <slot name="after-tabs" />
  </div>
</template>

<script>
  import { Scrolly, ScrollyBar, ScrollyViewport } from 'vue-scrolly';
  import { isIncomingTenderPage } from '@/utils/route-matcher';
  import Tab from '@/components/tabs/Tab';

  export default {
    name: 'TableTabs',
    components: {
      Tab,
      Scrolly,
      ScrollyViewport,
      ScrollyBar,
    },
    props: {
      summaryRoute: { type: Object, required: true },
      summaryClass: { type: Object },
      backgroundColor: { type: String, required: true },
      scrollbarClass: { type: Object },
      showScrollActions: Boolean,
    },
    methods: {
      isIncomingTenderPage,
      goToSummaryRoute() {
        this.$router.push(this.summaryRoute);
      },
    },
  };
</script>

<style scoped>
  .fade-out-block {
    height: 38px;
    width: 8px;
    z-index: 2;
    position: absolute;
    left: 0;
    bottom: 2px;
  }

  .fade-out-block.right {
    left: auto;
    right: 0;
  }

  .tables-tabs {
    padding-left: 8px;
  }
</style>
